<template>
  <footer class="strata-footer">
    <div class="container-fluid">
      <div class="row gy-4">

        <!-- Logo & Description -->
        <div class="col-md-4">
          <img
            src="assets/imagesLanding/new-logo.png"
            alt="DIY Strata Management"
            class="footer-logo"
          />
          <p class="footer-text mt-3">
            A highly qualified psychologist, has <br/> cultivated a distinguished
            career through <br /> rigorous training and diverse practical <br /> experiences.
          </p>

          <div class="footer-social mt-4">
            <i class="fab fa-facebook-f"></i>
            <i class="fab fa-x-twitter"></i>
            <i class="fab fa-instagram"></i>
          </div>
        </div>

        <!-- Platform -->
        <div class="col-md-2">
          <h5 class="footer-title">Platform</h5>
          <ul class="footer-links">
            <li><router-link to="/">Features</router-link></li>
            <li><router-link to="/pricing">Pricing</router-link></li>
            <li><router-link to="/about">About Us</router-link></li>
            <li><router-link to="/faq">FAQ</router-link></li>
          </ul>
        </div>

        <!-- Resources -->
        <div class="col-md-3">
          <h5 class="footer-title">Resources</h5>
          <ul class="footer-links">
            <li><a href="#">How to Switch</a></li>
            <li><a href="#">Privacy Policy</a></li>
            <li><a href="#">Terms of Service</a></li>
          </ul>
        </div>

        <!-- Contact -->
        <div class="col-md-3">
          <h5 class="footer-title">Contact Us</h5>
          <p class="footer-contact">
            <i class="fas fa-envelope"></i> stratayourself@gmail.com
          </p>
          <p class="footer-contact">
            <i class="fas fa-phone"></i> 1300 000 000
          </p>
          <p class="footer-contact">
            <i class="fas fa-comments"></i>
            Live chat available during business hours
          </p>
        </div>

      </div>
    </div>

    <!-- Bottom Bar -->
    <div class="footer-bottom">
      <div class="container-fluid d-flex flex-wrap justify-content-between">
        <p>© 2025 Strata Yourself. All rights reserved.</p>
        
        <div class="d-flex flex-wrap gap-3">
            <p class="footer-keywords">
          DIY strata management 
        </p>
        <p class="footer-keywords">
        •
        </p>
        <p class="footer-keywords">
        Self-managed strata Australia
        </p>
        <p class="footer-keywords">
        •
        </p>
        <p class="footer-keywords">
        AI chatbot strata NSW VIC QLD
        </p>
        </div>
      </div>
    </div>
  </footer>
</template>



<script>
export default {
 name: "FooterPage",
 props: {
   msg: String,
 },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped src="../../../public/assets/cssLanding/bootstrap.min.css"></style>
<style scoped src="../../../public/assets/fontsLanding/iconfonts.css"></style>
<style scoped src="../../../public/assets/cssLanding/plugins.css"></style>
<style scoped src="../../../public/assets/cssLanding/style.css"></style>
<style scoped src="../../../public/assets/cssLanding/responsive.css"></style>
<style scoped src="../../../public/assets/cssLanding/color.css"></style>

<style scoped>
.strata-footer {
  background: #1f4d3a; /* dark green */
  color: #ffffff;
  padding: 60px 115px 20px 115px;
}

.footer-logo {
  max-width: 200px;
}

.footer-text {
  font-size: 15px;
  line-height: 28px;
  color: #D1D5DB;
}

.footer-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 20px;
  text-shadow: none !important;
  color:#ffffff !important;
}

.footer-links {
  list-style: none;
  padding: 0;
}

.footer-links li {
  margin-bottom: 10px;
}

.footer-links a {
  color: #D1D5DB;
  text-decoration: none;
  opacity: 0.85;
}

.footer-links a:hover {
  opacity: 1;
}

.footer-contact {
  font-size: 15px;
  margin-bottom: 12px;
  color: #D1D5DB;
}

.footer-contact i {
  margin-right: 8px;
  color: #ffb703;
}

.footer-social i {
  font-size: 18px;
  margin-right: 15px;
  cursor: pointer;
}

.footer-bottom {
  margin-top: 60px;
  padding: 20px 0;
  font-size: 16px;
  color:#7A7A7A;
}

.footer-keywords {
  text-align: right;
  color:#7A7A7A;
}

@media (max-width: 768px) {
  .footer-keywords {
    text-align: left;
    margin-top: 10px;
  }
}

</style>
